import React from "react";
import { TMarketOps } from "../../../types/markets";

interface AuctionSlot {
  id: number;
  time: string;
}

interface DaySchedule {
  day: string;
  openTime?: string;
  closeTime?: string;
  isClosed?: boolean;
  auctions?: AuctionSlot[];
  noData?: boolean;
}

interface MarketHoursListProps {
  marketHoursList?: TMarketOps[];
}

const MarketHoursList: React.FC<MarketHoursListProps> = ({
  marketHoursList = [],
}) => {
  const allDays = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const schedule: DaySchedule[] = allDays.map((day) => {
    const dayEntries = marketHoursList.filter(
      (d) => d.day === day && d.status === 1
    );

    //closed
    if (dayEntries.some((d) => d.marketStatus === false)) {
      return { day, isClosed: true };
    }
    // no date
    if (dayEntries.length === 0) {
      return { day, noData: true };
    }
    // type working
    const working = dayEntries.find((d) => d.type === "WORKING");

    // type action
    const auctions =
      dayEntries
        .filter((d) => d.type === "AUCTION")
        .map((a) => ({
          id: a.id,
          time: `${a.startTime} to ${a.endTime}`,
        })) || [];

    return {
      day,
      ...(working
        ? { openTime: working.startTime, closeTime: working.endTime }
        : { noData: true }),
      ...(auctions.length ? { auctions } : {}),
    };
  });

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 overflow-hidden">
      {schedule.map((day) => (
        <div
          key={day.day}
          className="border-r border-b p-4 flex flex-col gap-2"
        >
          <div>
            <h3 className="color-sub-text fs-12 font-medium">{day.day}</h3>

            {day.isClosed ? (
              <p className="color-red font-semibold fs-14">Closed</p>
            ) : day.noData ? (
              <p className="color-text-secondary font-semibold fs-14">–</p>
            ) : (
              <>
                {day.openTime || day.closeTime ? (
                  <p className="color-primary font-semibold fs-14 mt-1">
                    {day.openTime} to {day.closeTime}
                  </p>
                ) : (
                  "-"
                )}
              </>
            )}
          </div>

          {!day.isClosed && day.auctions && day.auctions.length > 0 && (
            <div>
              <p className="color-sub-text fs-12 font-medium mb-1 mt-3">
                Auctions
              </p>
              <div className="flex flex-col gap-2">
                {day.auctions.map((auction, i) => (
                  <div key={auction.id} className="flex items-center gap-2">
                    <div className="bg-primary text-white w-5 h-5 flex items-center justify-center rounded-full text-sm font-semibold">
                      {i + 1}
                    </div>
                    <span className="color-text-primary fs-14 font-medium">
                      {auction.time}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default MarketHoursList;
